import { render, staticRenderFns } from "./AddOrEditEmployee.vue?vue&type=template&id=72265008&"
import script from "./AddOrEditEmployee.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditEmployee.vue?vue&type=script&lang=ts&"
import style0 from "./AddOrEditEmployee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports